module.exports = __webpack_public_path__ + "img/wellbore_activated.4aff5c25.svg";